import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { AE_palette } from '../style/theme';

export default function CircularIndeterminate({ size = 40, color = AE_palette.melonRed }) {
  return (
    <Box sx={{ 
      display: 'flex',
      justifyContent: 'center', 
      alignItems: 'center'
    }}>
      <CircularProgress size={size} color={color} />
    </Box>
  );
}